import { useEffect } from "react";
import AuthService from '../services/AuthServices';

function GoogleLoginButton() {
  useEffect(() => {
    if (window.google && !document.getElementById("g_id_signin")) {
      window.google.accounts.id.initialize({
        client_id: "257705405655-eo6gd9iak0d6709hlcg2dctu71g8vlkt.apps.googleusercontent.com",
        callback: handleCallbackResponse,
      });

      window.google.accounts.id.renderButton(
        document.getElementById("google-login"),
        { theme: "outline", size: "large" }
      );

      // Suivi clic avec mutation observer
    const observer = new MutationObserver(() => {
      const btn = document.querySelector('#google-login div[role=button]');
      if (btn && !btn.dataset.umamiAttached) {
        btn.addEventListener("click", () => {
          if (window.umami) window.umami.track('login-google-click');
        });
        btn.dataset.umamiAttached = "true";
      }
    });

    observer.observe(document.getElementById("google-login"), {
      childList: true,
      subtree: true,
    });
    
    }
  }, []);

  function onLogin(p_key) {
    // This function can be used to handle the login key
    console.log("User logged in with key:", p_key);
    AuthService.setConnectedKey(p_key); // ou une autre méthode d’enregistrement
    // window.location.reload();
    window.location.href = "/"; // Redirection vers la page d'accueil, car si on est sur /register le relod reste sur la page d'inscription
  }

  const handleCallbackResponse = (response) => {
    const idToken = response.credential;
    fetch("https://app.listaki.fr/api/WS/google-login.php", {
      method: "POST",
      mode: "cors",
      body: JSON.stringify({ token: idToken }),
      headers: { "Content-Type": "application/json" },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.key) {
          onLogin(data.key);
        } else {
          alert("Erreur d'authentification Google.");
        }
      });
  };

  return <div id="google-login"></div>;
}

export default GoogleLoginButton;
